import type { FC } from 'react'

import { AuthClient } from '@skytech/auth'
import { Toggle } from '@skytech/ui'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'
import { Link } from 'react-router-dom'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import useBetaAccess from '@/hooks/beta-access'
import { useEditTranslationsPrivilege, useFullUserName, useProfile } from '@/hooks/user'
import { appRoutes } from '@/util/misc'

import './account-details.scss'

const AccountDetails: FC = () => {
  const { whiteLabel, isEditTranslationsMode, setIsEditTranslationsMode } = useAppContext()
  const profile = useProfile()
  const fullName = useFullUserName()
  const email = profile?.email
  const phoneNumber = profile?.phoneNumber
  const dealer = profile?.dealer
  const editTranslationsPrivilege = useEditTranslationsPrivilege()

  const { isFullBetaUser } = useBetaAccess()

  return (
    <div className="account-details">
      <h4>
        <Translation id="Logged in as" />
      </h4>

      {fullName && <p className="name">{fullName}</p>}

      {email && <p>{email}</p>}

      {phoneNumber && <p>{phoneNumber}</p>}

      {dealer && <p>{dealer}</p>}

      {isFullBetaUser && <Link to={appRoutes.whiteLabel}>Set whitelabel</Link>}

      {['CAN_EDIT_OWN_LANG', 'CAN_EDIT_ALL_LANG'].includes(editTranslationsPrivilege) && (
        <Toggle
          id="edit-translations-mode"
          label={<Translation id="Edit translations mode" />}
          checked={isEditTranslationsMode}
          marginBottom={16}
          marginTop={16}
          onChange={() => setIsEditTranslationsMode(!isEditTranslationsMode)}
          whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
        />
      )}

      <button onClick={() => AuthClient.logOut()}>
        <Translation id="Logout" />
      </button>
    </div>
  )
}

export default AccountDetails
